
export class PhotoUploadQueueNumber {
	public queueNumber;
	public signedUploadUrlNumber;
}